"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_FLAVORS = void 0;
var client_1 = require("@apollo/client");
exports.GET_PRODUCT_FLAVORS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetProductFlavors($searchTerm: String) {\n    productFlavors(searchTerm: $searchTerm) {\n      id\n      flavor\n      displayFlavor\n    }\n  }\n"], ["\n  query GetProductFlavors($searchTerm: String) {\n    productFlavors(searchTerm: $searchTerm) {\n      id\n      flavor\n      displayFlavor\n    }\n  }\n"])));
var templateObject_1;
